"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddSiblingNode = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const AddSiblingNode = ({ size = 16 }) => (react_1.default.createElement(Base_1.Base, { size: size },
    react_1.default.createElement("path", { fill: "#E6E6E6", d: "M11,0v7H8v2H7V7H4V0H11z" }),
    react_1.default.createElement("path", { fill: "#8EE43F", d: "M4,9v7h7V9H4z M10,13H8v2H7v-2H5v-1h2v-2h1v2h2V13z" })));
exports.AddSiblingNode = AddSiblingNode;
//# sourceMappingURL=AddSiblingNode.js.map